var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('h4',[_vm._v("Confirmação dos dados")]),_c('event-info-core-details',{attrs:{"event":_vm.event}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }